<template>
  <div :ref="`ascSplitButton${_uid}`" class="asc-split-button">
    <asc-accent-button
      class="asc-split-button--accent-button"
      button-text="Export"
      :on-click="handleToggle"
      :disabled="disabled"
    ></asc-accent-button>
    <div
      v-if="showMenu"
      v-click-outside="handleClickOutsideClick"
      :class="['asc-split-button--menu', getMenuRightOffsetClass]"
    >
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :disabled="item.disabled"
          @click="handleItemClick(item.value)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>

<script>
import AscAccentButton from './AscAccentButton'

export default {
  name: 'AscSplitButton',

  components: {
    AscAccentButton,
  },

  props: {
    buttonText: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onItemClick: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      showMenu: false,
    }
  },

  computed: {
    getMenuRightOffsetClass() {
      const container = this.$refs[`ascSplitButton${this._uid}`]
      const buttons = container.getElementsByClassName(
        'asc-split-button--accent-button',
      )
      if (buttons.length > 0) {
        const button = buttons[0]
        const buttonWidth = 250
        const buttonOffsetLeft = button.offsetLeft
        const buttonParentOffsetWidth = button.offsetParent.offsetWidth
        const buttonOffsetLeftWidth = buttonOffsetLeft + buttonWidth
        const isNeedsOffset = buttonOffsetLeftWidth > buttonParentOffsetWidth
        return isNeedsOffset ? 'asc-split-button--menu-right' : ''
      }

      return ''
    },
  },

  watch: {
    selectedItem(newValue) {
      if (newValue !== null) {
        this.handleItemClick(newValue)
        this.selectedItem = null
      }
    },
  },

  methods: {
    handleToggle() {
      this.showMenu = !this.showMenu
    },

    handleItemClick(value) {
      this.handleToggle()
      if (this.onItemClick) {
        this.onItemClick(value)
      }
    },

    handleClickOutsideClick() {
      if (this.showMenu) {
        this.handleToggle()
      }
    },
  },
}
</script>

<style lang="scss">
.asc-split-button {
  position: relative;
  display: inline-block;

  .asc-split-button--menu {
    margin-top: 4px;
    z-index: 8;
    border-radius: 2px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3) !important;
    display: flex;
    flex-direction: column;
    position: absolute;
    min-width: 150px;
    max-width: 250px;
  }

  .asc-split-button--menu-right {
    right: 0;
  }

  & .v-list-item {
    border-left: 4px solid transparent;

    &:hover {
      border-left: 4px solid $gray-100;
      color: $primary-black;
      background-color: $gray-100 !important;
      text-decoration: none;
    }
  }

  & .v-list > div {
    background-color: $primary-white;
  }

  & .v-list-item--link {
    color: inherit;
    font-size: 14px;
  }

  & .v-list {
    padding: 0;
    max-height: 365px;
  }
}
</style>
